import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/app/providers/SessionProviderWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/components/CustomScrollBar/CustomScrollBar.jsx");
;
import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/node_modules/react-phone-input-2/lib/material.css");
;
import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/redux/Provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootStyleRegistry"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/RootStyleRegistry.jsx");
;
import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/styles/Globals.scss");
